import Immutable, { Map, OrderedMap, List } from 'immutable'

export const GRAPHQL_DATA_FETCHED = 'GRAPHQL/DATA_FETCHED'

export function dataFetched(payload, meta) {
  return {
    type: GRAPHQL_DATA_FETCHED,
    payload,
    meta: {
      graphql: meta,
    },
  }
}

function simpleObjectMerger(previousValue = Map(), newValue) {
  return previousValue.merge(newValue)
}

function isImmutable(object) {
  return !!object.toJS
}

export function dataFetchedReducerFactory({
  refBuilder,
  entityMergers,
  getEntityKeyField = obj => 'id',
  defaultEntityMerger = simpleObjectMerger,
}) {
  return function dataFetchedReducer(state, payload) {
    const entity = isImmutable(payload) ? payload : Immutable.fromJS(payload)
    const __typename = entity.get('__typename')
    const attributes = entity.remove('__typename')
    const entityNormalizer = attributes
      .keySeq()
      .toList()
      .reduce(
        (memoNormalizer, attributeName) => {
          const attribute = entity.get(attributeName)
          if (
            List.isList(attribute) &&
            attribute.size > 0 &&
            Map.isMap(attribute.get(0)) &&
            attribute.get(0).get('__typename')
          ) {
            const attributeNormalized = attribute.reduce(
              (memo, ref) => {
                const keyField = getEntityKeyField(ref)
                const key = ref.get(keyField)
                const __typename = ref.get('__typename')
                return memo
                  .setIn(
                    ['refs', key],
                    refBuilder({ [keyField]: key, __typename })
                  )
                  .updateIn(['innerQueue'], innerQueue => innerQueue.push(ref))
              },
              Map({
                refs: OrderedMap(),
                innerQueue: List(),
              })
            )
            return memoNormalizer
              .setIn(
                ['normalized', attributeName],
                attributeNormalized.get('refs')
              )
              .updateIn(['queue'], queue =>
                queue.concat(attributeNormalized.get('innerQueue'))
              )
          }

          if (
            attribute != null &&
            Map.isMap(attribute) &&
            attribute.get('__typename')
          ) {
            const keyField = getEntityKeyField(attribute)
            const key = attribute.get(keyField)
            const __typename = attribute.get('__typename')
            return memoNormalizer
              .setIn(
                ['normalized', attributeName],
                refBuilder({ [keyField]: key, __typename })
              )
              .updateIn(['queue'], queue => queue.push(attribute))
          }
          return memoNormalizer.setIn(['normalized', attributeName], attribute)
        },
        Map({
          normalized: Map(),
          queue: List(),
        })
      )

    // retrieve existing version of the entity if it exists
    const typenameMap = state.get(__typename) || Map()
    const keyField = getEntityKeyField(entity)
    const existingEntity = typenameMap.get(entity.get(keyField))

    // merge ad map new entity version with existing
    const entityMerger = entityMergers[__typename]
    const mappedEntity = entityMerger
      ? entityMerger(existingEntity, entityNormalizer.get('normalized'))
      : defaultEntityMerger(existingEntity, entityNormalizer.get('normalized'))

    // iterate over the the queue of nested stuff, retrieve a new state
    const updatedState = entityNormalizer
      .get('queue')
      .reduce(dataFetchedReducer, state)

    // add the new entity to the typename map of the freshed version of the state
    const freshTypenameMap = updatedState.get(__typename) || Map()
    const updatedTypenameMap = freshTypenameMap.set(
      entity.get(keyField),
      mappedEntity
    )
    return updatedState.set(__typename, updatedTypenameMap)
  }
}
